import { AsyncPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';

import { PrivaContentHeaderComponent } from '@priva/components/content-header';
import { PrivaContentSectionComponent } from '@priva/components/content-section';
import { PrivaContentTemplateComponent } from '@priva/components/content-template';
import { PrivaHeaderComponent } from '@priva/components/header';
import { PrivaLocalizationModule, PrivaLocalizationService } from '@priva/localization';

import { AppPrimaryNavigationService } from 'app/core/routing';

import { ActivitySelectorStore } from './activity-selector.store';
import { ActivityFilterComponent, ActivityListComponent } from './components';
import { Activity } from './models';

@Component({
    selector: 'app-activity-selector',
    templateUrl: './activity-selector.component.html',
    styleUrl: './activity-selector.component.scss',
    imports: [
        AsyncPipe,
        PrivaContentHeaderComponent,
        PrivaContentSectionComponent,
        PrivaContentTemplateComponent,
        PrivaLocalizationModule,
        PrivaHeaderComponent,
        ActivityFilterComponent,
        ActivityListComponent,
    ],
    providers: [ActivitySelectorStore],
})
export class ActivitySelectorComponent {
    private componentStore = inject(ActivitySelectorStore);
    private navigation = inject(AppPrimaryNavigationService);
    privaLocalizationService = inject(PrivaLocalizationService);

    activities = input(undefined, {
        transform: (value: Activity[]) => {
            this.componentStore.updateActivities(value);
        },
    });

    activitySelected = output<Activity>();

    readonly activities$ = this.componentStore.activities$;
    readonly filteredActivities$ = this.componentStore.filteredActivities$;
    readonly initializationFinished$ = this.componentStore.initializationFinished$;

    resetSearchTermsSignal = 0;

    get pageName(): string {
        const pageName = this.navigation.getNavigation()?.label;
        return pageName ? this.privaLocalizationService.instant(pageName) : '';
    }

    onActivitySelected(activity: Activity): void {
        this.resetSearchTermsSignal = Date.now();
        this.activitySelected.emit(activity);

        this.componentStore.onActivitySelected(activity);
    }

    onFilteredActivitiesChanged(list: Activity[]) {
        setTimeout(() => this.componentStore.updateFilteredActivities(list));
    }
}
